export default __webpack_public_path__ + "static/media/Black-sallallahu-alaihi-wasallam.9ab07a7f.png";